import {SpaceProto} from "../../../model2/space/space-proto"

// const debug = 'selectParent_getInitialCurrentSection'
const debug = false

export const selectParent_getInitialCurrentSection = (selectedProjects:ID[], spaces: SpaceProto[], canBeUndefined: boolean) => {

    // collect all ids of spaces from selected projects
    let selectedSpacesIds: ID[] = []
    _.map(selectedProjects, (projectId: ID)=>{
        const workspace = gd.spaces.workspaces.getByProjectId(projectId)
        if (workspace) {
            selectedSpacesIds.push(workspace.id)
        } else {
            const project = gd.session.projects.get(projectId)
            project && selectedSpacesIds.push(project.space.id)
        }
    })
    selectedSpacesIds = _.uniq(selectedSpacesIds)

    // loop through this.spaces to find first one that is among selected
    let currentSection = !canBeUndefined ? spaces[0] : undefined
    _.some(spaces, (space: SpaceProto)=>{
        if (selectedSpacesIds.includes(space.id)) {
            currentSection = space
            return true
        }
    })

    return currentSection
}